import * as React from 'react';
import { Table, TabContent, TabPane, Nav, NavItem, NavLink, Card, Button, CardTitle, CardText, Row, Col, Label, Input } from 'reactstrap';
import { useState, useEffect } from 'react';
import Page from '../Page';
import { useAppSelector, useAppDispatch } from '../../hooks/index';
import { Entity, getSelectedEntity } from '../../redux/EntitySlice';
import {
    Afr, getSelectedAfr, updateVersionStateValue, generateLocalStateFromEventProperties, versionStateValue, updateTableFact, existFactsInTable, getTable, hasNoDataFact,
    removeNoDataFact, addNoDataFact
} from '../../redux/AfrSlice';
import RevenuesCoreDetail from '../AfrCore/RevenuesCoreDetail';
import RevenuesCoreImpactFees from '../AfrCore/RevenuesCoreImpactFees';
import { setIsDirty, isAdmin, getTaxonomyType, getSectionDimensionMap } from '../../redux/MiscSlice';
import { Concept, resetConceptState } from "../../redux/ConceptSlice";
import utilityHelper from '../../utils/utilityHelper';
import { useLocation } from 'react-router-dom';
import enums from '../../utils/enums';
import { AccountEditorGridNoSubAccountBulk, IAccountEditorGridNoSubaccountsOptions } from '../core/AccountEditorGridNoSubAccountBulk';
import { ColumnAccountEditorGrid } from '../core/ColumnAccountEditorGrid';
import { RowDimensionEditorGrid } from '../core/RowDimensionEditorGrid';
import { loadDefinitionNetworkRoot, NetworkDetailsRequest, selectDefinitionNetworkRoot } from '../../redux/NetworkSlice';
import { ActiveTaxonomyVersionInfo, selectCurrentVersion, TaxonomyTypeEnum } from '../../redux/TaxonomyVersionSlice';
import { getTaxonomy } from '../../redux/DocumentsSlice';
import { Node, Edge } from '../../redux/EntitiesSlice';

const getReviewKey = function (dataSection: string) {
    return "reviewState_cr29" + dataSection + "Reviewed";
}
const CR29DataCore = (props: { userRole: string, dataSection: string }) => {
    const dispatch = useAppDispatch();

    const networkRoot: Node | null = useAppSelector(selectDefinitionNetworkRoot);
    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    const afrYear = currentAfr ? currentAfr.year : 0;
    const entity: Entity | null = useAppSelector(getSelectedEntity);
    const ename = entity ? entity.name : "";
    const ecode = entity ? entity.code : "";
    const [state, setState] = useState(generateLocalStateFromEventProperties(currentAfr, ["workState_" + props.dataSection, getReviewKey(props.dataSection)]));
    const [activeTab, setActiveTab] = useState("1");
    const [hasFacts, setHasFacts] = useState(true);
    const [bsDocumentation, setBsDocumentation] = useState<string[]>([]);
    const [sectionTitle, setSectionTitle] = useState<string>("");
    const [sectionTableTitles, setSectionTableTitles] = useState<string[]>([]);
    const [sectionTableNames, setSectionTableNames] = useState<any>({});
    const [balanceForward, setBalanceForward] = useState<number>(0);
    const [noData, setNoData] = useState<boolean>(false);

    const isAdminUser: boolean = useAppSelector(isAdmin);
    /* ************************************** Redux ********************************************/

    const toggle = (tab: string) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
            utilityHelper.saveDeferredChanges(dispatch);
        }
    }

    const activeClass = (tab: string) => {
        return (tab === activeTab) ? "active" : "";
    }


    const currVersion = function () {
        if (currentAfr) {
            if (currentAfr.currentversion) {
                if (currentAfr.currentversion.versionState) {
                    return currentAfr.currentversion.versionState;
                }
            }
        }
        return null;
    }

    const getTableNames = function (dsection: string): string[] {
        var results: string[] = [];
        ["", "_1", "_2", "_3"].map(s => {
            var tKey = dsection + s;
            if (sectionTableNames.hasOwnProperty(tKey)) {
                results.push( sectionTableNames[dsection] );
            }
        });
        return results;
    }
    // Cell Handler
    const handleCellEdited = function (cell: any) {
        var tblName = cell.getTable().getId();
        var row = cell.getRow();
        var rowid = row.getData().accountCode;
        var conceptId = row.getData().accountId;
        var fieldid = cell.getField();
        var newvalue = cell.getValue();
        dispatch(updateTableFact(
            {
                tableId: tblName,
                rowId: rowid,
                fundGroup: fieldid,
                concept: conceptId,
                value: newvalue
            }));

    }

    const handleChangeCheckbox = function (event: any) {

        var checkValues = JSON.parse(JSON.stringify(state));
        var key: string = event.target.name;
        var value: boolean = event.target.checked

        setState(checkValues);

        // here call to dispatcher sending:
        var eventFirstlevel = key.split("_")[0]
        var eventSecondlevel = key.split("_")[1]

        // Update global flag for this event in redux
        dispatch(updateVersionStateValue({ propGroup: eventFirstlevel, propName: eventSecondlevel, boolValue: value, value: null }));

        // set the dirty flag to TRUE
        dispatch(setIsDirty({ IsDirty: true, Page: "" }));

    }

    const editorOptions: IAccountEditorGridNoSubaccountsOptions = {
        gridname: props.dataSection,
        cellEditHandler: handleCellEdited,
        doneFlag: "workState_revenesComplete",
        noFlag: "workState_noRevenues",
        fixedRows: true,
        firstFieldId: "defaultHeight",
        allowedCombinations: null,
        dimensionColumn: null,
        accountRangeFilter: null,
        accountGroups: null,
        columnFilter: null
    };

    const headerStyle = {
        margins: "4em, 0, 0, 0",
        backgroundColor: "green"
    }
    useEffect(() => {
        setNoData(true);
        if (!currentAfr) return;
        if (!currentAfr.currentversion) return;
        // get state from redux
        var newLocalState = generateLocalStateFromEventProperties(currentAfr, ["workState_" + props.dataSection, getReviewKey(props.dataSection)])

        // enable/disable checkbox when there are (no) facts 
        setHasFacts(existFactsInTable(currentAfr, ["29-court-reporting",
            "cr29-court-reporting-local-requirements-collections",
            "cr29-court-reporting-non-recurring-expenditures",
            "cr29-court-reporting-facility-cost",
            "cr29-court-reporting-communications-systems-and-services",
            "cr29-court-reporting-existing-systems",
            "cr29-court-reporting-local-requirements",
            "cr29-court-reporting-other-operating-court-related-expenditures"
        ]));
        setNoData(hasNoDataFact(currentAfr, props.dataSection));
        // create a local state from redux
        setState(newLocalState)

    }, [currentAfr, currVersion()])

    useEffect(() => {
        var sectKey = props.dataSection.replace(" ", "_").toUpperCase();
        setSectionTitle(enums.CR29PartDescriptors[sectKey + "_TITLE"]);
        var tableTitles: string[] = [];
        var tableNames: any = {};
        ["", "_1", "_2", "_3"].map(s => {
            var tKey = sectKey + "_TABLE_TITLE" + s;
            if (enums.CR29PartDescriptors.hasOwnProperty(tKey)) {
                tableTitles.push(enums.CR29PartDescriptors[tKey]);
            }
            var tNameKey = sectKey + "_TABLE_NAME" + s;
            if (enums.CR29PartDescriptors.hasOwnProperty(tNameKey)) {
                tableNames[enums.CR29PartDescriptors[tKey]] = enums.CR29PartDescriptors[tNameKey];
            }
            var tPartNameKey = props.dataSection + s;
            if (enums.CR29PartDescriptors.hasOwnProperty(tNameKey)) {
                tableNames[tPartNameKey] = enums.CR29PartDescriptors[tNameKey];
            }


        });
        setSectionTableTitles(tableTitles);
        setSectionTableNames(tableNames);
        var bTotal = 0;
        setBalanceForward(bTotal);

    }, [])

    return (
        <React.Fragment>
            <Page>
                <h2>{sectionTitle} for {ename} ({ecode}), {utilityHelper.getAfrYearDescriptor(currentAfr)}</h2>
                <Row >
                    <Col>
                        <div hidden={!isAdminUser} className="box-events pl-2 pr-3 py-3 my-2">
                            <div>
                                {isAdminUser && (
                                    <Label className="ml-5" check>
                                        <Input type="checkbox"
                                            name={getReviewKey(props.dataSection)}
                                            onChange={handleChangeCheckbox}
                                            disabled={!utilityHelper.checkStatusList(currentAfr, enums.certifiedRecertified)}
                                            checked={state[getReviewKey(props.dataSection)] ? true : false}
                                        /><b>Reviewed</b>
                                    </Label>)}
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div>
                            {
                                sectionTableTitles.map((sTitle : string, idx) => 
                                    <Row style={{ marginBottom: "2em" }}>
                                        <Col>
                                            <div><h2 >{sTitle}</h2></div>
                                            <div>
                                                <AccountEditorGridNoSubAccountBulk
                                                    tableName={sectionTableNames[sTitle]}
                                                    gridData={[]}
                                                    gridColumns={[]}
                                                    gridOptions={{}}
                                                    options={{ ...editorOptions, gridname: sectionTableNames[sTitle] }}
                                                    setHasData={setHasFacts}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                )
                            }
                        </div>
                    </Col>
                </Row>
            </Page>
        </React.Fragment>
    );
}

export default CR29DataCore;